export const FISERV_TOKEN_TYPE_CLAIM_CHECK_NONCE = 'CLAIM_CHECK_NONCE' as const;
